interface TourOrderConfirmationTextProps {
  className?: string;
  visible?: boolean;
  title: string;
  message: string;
}

export function TourOrderConfirmationText({
  visible = true,
  title,
  message,
  className
}: TourOrderConfirmationTextProps) {
  if (!visible) return null;

  return (
    <div className={`order-confirmation__complete ${className || ""}`}>
      <div className="order-confirmation__complete-text">
        <p className="zeta">
          <strong>
            <div className="order-confirmation__order-confirmed">
              <div className="order-confirmation__order-confirmed-title">{title}</div>
              <div className="order-confirmation__order-confirmed-text">{message}</div>
            </div>
          </strong>
        </p>
      </div>
    </div>
  );
}

export default TourOrderConfirmationText;
